import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-sidepanel-activity-error-omissions',
  templateUrl: './sidepanel-activity-error-omissions.component.html',
  styleUrls: ['./sidepanel-activity-error-omissions.component.css']
})
export class SidepanelActivityErrorOmissionsComponent implements OnInit {

  @Input() hide: boolean;
  @Output() hideSideBar = new EventEmitter<any>();
  @Output() closeOnly = new EventEmitter<any>();  
  @Input() sidePanelData;
  @Input() eandO;
 
  attachmentCount: number = 0;
  archiveAttachmentCount: number = 0;
  notesCount: number = 0;
  
  constructor() { }

  ngOnInit(): void {
   
  }

  
  closePopup(id){
    this.hide = !this.hide;
    this.hideSideBar.emit(this.hide);
    this.closeOnly.emit(id);    
  }

  getEandONotesCountEvent(count: number) {
    this.notesCount = count;
  }

}
